import { normalCdf } from "./normalCdf";

// computes sign-test p-values for every ordered pair of methods
export function computePairBrackets(winMatrix, order) {
    const N = order.length;
    const brackets = [];
    for (let a = 0; a < N - 1; a++) {
        for (let b = a + 1; b < N; b++) {
            const origA = order[a];
            const origB = order[b];
            const nij = winMatrix[origA][origB];
            const nji = winMatrix[origB][origA];
            const n = nij + nji;
            if (n === 0) continue;
            const z = (nij - n / 2) / Math.sqrt(n / 4);
            const p = 2 * (1 - normalCdf(Math.abs(z)));
            brackets.push({ i: a, j: b, p });
        }
    }
    return brackets;
}
